import Web3 from "web3";
import create from "zustand";
import { devtools, persist } from "zustand/middleware";
import {
  WALLET_TYPES,
  WalletConnectorState,
  WalletConnectorActions,
  initialWalletConnectorState,
} from "../walletConnectorInterfaces";

export const useWalletConnector = create<
  WalletConnectorState & WalletConnectorActions
>()(
  devtools(
    persist(
      (set) => ({
        ...initialWalletConnectorState,
        catchWalletConnectError: (error: any) => {
          console.log("catchWalletConnectError", error);
          set((state) => ({
            ...state,
            error: error,
          }));
        },
        setRPCUrl: (rpcUrl: string) => {
          console.log("setRPCUrl", rpcUrl);
          set((state) => ({
            ...state,
            rpcUrl: rpcUrl,
          }));
        },
        connectWallet: (currentWallet: WALLET_TYPES, rpcUrl: string) => {
          console.log("connectWallet", currentWallet);
          set((state) => ({
            ...state,
            rpcUrl: rpcUrl,
            currentWallet: currentWallet,
            isConnecting: true,
            isConnected: false,
            walletAddress: "",
            walletBalance: "",
            currentNetworkChainId: 0,
            error: "",
            web3Sdk: undefined,
            isWeb3Initialized: false,
          }));
        },
        walletConnected: (
          walletAddress: string,
          walletBalance: string,
          currentNetworkChainId: number,
          web3Sdk: Web3
        ) => {
          console.log(
            "walletConnected",
            walletAddress,
            walletBalance,
            currentNetworkChainId
          );
          set((state) => ({
            ...state,
            isConnected: true,
            isConnecting: false,
            walletAddress: walletAddress,
            walletBalance: walletBalance,
            currentNetworkChainId: currentNetworkChainId,
            error: "",
            web3Sdk: web3Sdk,
            isWeb3Initialized: true,
          }));
        },
        resetWalletConnector: () => {
          console.log("resetWalletConnector");
          set(() => ({
            ...initialWalletConnectorState,
          }));
        },
      }),
      {
        name: "walletConnector",
        getStorage: () => sessionStorage,
        partialize: (state) => ({
          isConnected: state.isConnected,
          currentWallet: state.currentWallet,
          walletAddress: state.walletAddress,
          rpcUrl: state.rpcUrl,
          currentNetworkChainId: state.currentNetworkChainId,
        }),
      }
    )
  )
);
